/**
 * Created by iamso on 06.08.19.
 */

const TreasureSearch = function (mission) {
    cleverapps.EventEmitter.call(this);
    this.running = true;
    this.paused = false;
    this.mission = mission;
    this.type = cleverapps.config.ui === "tropical" ? TreasureSearch.TYPE_FISHING : TreasureSearch.TYPE_GARDEN;

    const fieldSize = TreasureSearch.FIELD_SIZE_BY_STAGES[this.getStage()];

    this.seed = mission.details && mission.details.seed;
    this.opened = {};

    if (mission.details) {
        cleverapps.fromBit(mission.details.opened).forEach(function (cellId) {
            const row = Math.floor(cellId / fieldSize.height);
            const col = cellId % fieldSize.width;
            this.opened[`${col}_${row}`] = cellId;
        }, this);
    }

    if (this.seed === undefined) {
        this.seed = Date.now();
        this.opened = {};
    }

    this.createField(fieldSize);
};

TreasureSearch.prototype = Object.create(cleverapps.EventEmitter.prototype);
TreasureSearch.prototype.constructor = TreasureSearch;

TreasureSearch.prototype.pause = function () {
    this.paused = true;
};

TreasureSearch.prototype.resume = function () {
    this.paused = false;
};

TreasureSearch.prototype.finish = function () {
    if (this.running) {
        this.running = false;
        this.trigger("finish");
    }
};

TreasureSearch.prototype.getInfo = function () {
    const cells = Object.keys(this.opened);

    if (cells.length === 0) {
        return {};
    }

    const opened = [];

    cells.forEach(function (cell) {
        opened.push(this.opened[cell]);
    }, this);

    return {
        seed: this.seed,
        opened: cleverapps.toBit(opened)
    };
};

TreasureSearch.prototype.createField = function (fieldSize) {
    const items = TreasureSearch.ITEMS_BY_STAGE[this.getStage()];
    const shapes = Object.keys(items).map((type) => {
        const shape = [];
        const size = items[type].split("x");
        for (let row = 0; row < size[0]; row++) {
            shape.push([]);
            for (let col = 0; col < size[1]; col++) {
                shape[row].push(type);
            }
        }
        return shape;
    }).sort((a, b) => Array.prototype.concat.apply([], b).length - Array.prototype.concat.apply([], a).length);

    let placedShapes = 0;
    let seed = this.seed;
    let attempt = 0;

    let shapeRotation;
    let goals;

    while (placedShapes !== shapes.length) {
        const field = [];
        goals = {};
        shapeRotation = {};
        let cells = [];

        placedShapes = 0;

        for (let h = 0; h < fieldSize.height; h++) {
            field[h] = [];
            for (let w = 0; w < fieldSize.width; w++) {
                field[h][w] = TreasureSearch.CELL_EMPTY;

                cells.push({ row: h, col: w });
            }
        }

        const pseudo = PseudoRandom.GET("tsearch");
        pseudo.seed(seed);
        cells = pseudo.shuffle(cells);

        shapes.forEach((shape, index) => {
            const code = shape[0][0];
            pseudo.seed(seed + index);
            const rotation = pseudo.choose([0, -90, 90]);

            if (rotation !== 0) {
                // 90 degrees clockwise rotation
                shape = shape[0].map((val, index) => shape.map(((row) => row[index])).reverse());
                shapeRotation[code] = rotation;
            }

            for (let i = 0; i < cells.length; i++) {
                const head = cells[i];

                if (field[head.row][head.col] !== TreasureSearch.CELL_EMPTY) {
                    continue;
                }

                const freeArea = [];

                for (let row = 0; row < shape.length; row++) {
                    for (let col = 0; col < shape[0].length; col++) {
                        if (field[head.row + row] && field[head.row + row][head.col + col] === TreasureSearch.CELL_EMPTY) {
                            freeArea.push({ row, col });
                        }
                    }
                }

                if (freeArea.length === shape.length * shape[0].length) {
                    freeArea.forEach((place) => {
                        const r = head.row + place.row;
                        const c = head.col + place.col;

                        field[r][c] = code;

                        if (!goals[code]) {
                            goals[code] = [];
                        }

                        goals[code].push({ row: r, col: c });
                    }, this);

                    placedShapes++;
                    break;
                }
            }
        });

        seed += 1;

        attempt++;
        if (attempt > 1000) {
            cleverapps.throwAsync(`Cant place all shapes after 1000 attempts. Field size: ${fieldSize.width}x${fieldSize.height}`);
            break;
        }
    }

    this.shapeRotation = shapeRotation;
    this.goals = goals;
};

TreasureSearch.prototype.open = function (col, row) {
    if (this.isOpened(col, row)) {
        return;
    }

    if (!this.canTakeCurrency()) {
        this.trigger("notEnoughCurrency");

        return;
    }

    const fieldSize = TreasureSearch.FIELD_SIZE_BY_STAGES[this.getStage()];
    this.opened[`${col}_${row}`] = fieldSize.height * row + col;
    this.updateCurrency(-this.mission.getMinigamePrice(), this.getInfo());
    const goalType = this.getGoalType(col, row);
    const isGoalOpened = this.isGoalOpened(goalType);

    this.trigger("open", {
        row,
        col,
        openedGoal: isGoalOpened && goalType
    });
    cleverapps.tutorial.trigger("TreasureSearchOpen");

    if (this.isStageCompleted()) {
        const currentStage = this.getStage();
        const stageReward = this.getStageReward(currentStage);
        const rewardsList = new RewardsList(stageReward, {
            event: this.mission.name,
            toBubbleStack: true
        });
        rewardsList.receiveRewards();

        this.mission.logEvent(Mission.EVENTS.MISSION_PROGRESS, {
            index: currentStage
        });
        this.mission.logEvent(Mission.EVENTS.MISSION_PROGRESS_DAU, { once: true });
        this.mission.logDailyReward(currentStage);
        this.mission.logEvent(Mission.EVENTS.MISSION_REWARD_VALUE, {
            reward: rewardsList,
            itemId: `${currentStage}`
        });
        this.seed = Date.now();
        this.opened = {};
        this.mission.update(1, this.getInfo());
        this.mission.logEvent(Mission.EVENTS.MISSION_STAGE, { itemId: `${this.mission.result}` });

        if (this.isFinished()) {
            this.complete();
            this.finish();
        } else {
            this.createField(TreasureSearch.FIELD_SIZE_BY_STAGES[this.getStage()]);
        }

        this.trigger("completeStage", currentStage, rewardsList);
    }
};

TreasureSearch.prototype.isOpened = function (col, row) {
    return this.opened[`${col}_${row}`] !== undefined;
};

TreasureSearch.prototype.getGoalType = function (col, row) {
    return Object.keys(this.goals).find((type) => this.goals[type].some((cell) => col === cell.col && row === cell.row));
};

TreasureSearch.prototype.isGoalOpened = function (goalType) {
    return this.goals[goalType] && this.goals[goalType].every((cell) => this.isOpened(cell.col, cell.row));
};

TreasureSearch.prototype.getStage = function () {
    return Math.min(this.mission.result, TreasureSearch.FIELD_SIZE_BY_STAGES.length - 1);
};

TreasureSearch.prototype.getCurrency = function () {
    return this.mission.currency;
};

TreasureSearch.prototype.canTakeCurrency = function () {
    return this.getCurrency() >= this.mission.getMinigamePrice();
};

TreasureSearch.prototype.isStageCompleted = function () {
    let allGoalsFound = true;

    Object.keys(this.goals).forEach(function (type) {
        this.goals[type].forEach(function (goal) {
            if (!this.isOpened(goal.col, goal.row)) {
                allGoalsFound = false;
            }
        }, this);
    }, this);

    return allGoalsFound;
};

TreasureSearch.prototype.isFinished = function () {
    return this.mission.logic.isFinished();
};

TreasureSearch.prototype.complete = function () {
    this.mission.logic.checkComplete();
};

TreasureSearch.prototype.getStageReward = function (stage) {
    const reward = RewardsConfig.TreasureSearch.stages[stage];
    return typeof UnitsLibraryHelper !== "undefined" ? UnitsLibraryHelper.ResolveRewardUnits(reward) : reward;
};

TreasureSearch.prototype.updateCurrency = function (amount, details) {
    this.mission.logic.processEvent({
        amount,
        details
    });
};

TreasureSearch.FIELD_SIZE_BY_STAGES = [
    { width: 4, height: 4 },
    { width: 5, height: 5 },
    { width: 5, height: 5 },
    { width: 6, height: 6 },
    { width: 7, height: 7 }
];

TreasureSearch.ITEMS_BY_STAGE = [{
    k: "3x2",
    j: "2x2",
    h: "2x1",
    g: "1x1"
}, {
    k: "1x1",
    j: "2x2",
    h: "2x1",
    g: "1x1"
}, {
    k: "1x1",
    j: "2x2",
    h: "2x1",
    g: "1x1"
}, {
    k: "1x1",
    j: "2x2",
    h: "2x1",
    g: "1x1"
}, {
    k: "1x1",
    j: "1x1",
    h: "2x1",
    g: "1x1"
}];

TreasureSearch.CELL_EMPTY = "e";

TreasureSearch.CURRENCY_HINT = "TreasureSearchWindow.Currency.Text";

TreasureSearch.TYPE_GARDEN = 0;
TreasureSearch.TYPE_FISHING = 1;